import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  return (
    <section id="referenzen" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="reveal text-center max-w-2xl mx-auto">
          <span className="text-[13px] font-bold tracking-[0.22em] text-blue-600 uppercase">
            Referenzen
          </span>
          <h2 className="font-display mt-3 text-slate-900 text-[30px] sm:text-[44px] tracking-tight leading-[1.05]" style={{ fontWeight: 900 }}>
            Was unsere Kunden sagen
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className="reveal relative bg-white rounded-2xl p-7 border border-slate-200 shadow-sm hover:shadow-xl hover:shadow-slate-200/60 hover:-translate-y-1 transition-all duration-300"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <Quote className="w-9 h-9 text-blue-100 mb-4" fill="currentColor" />
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 text-amber-400 fill-amber-400" />
                ))}
              </div>
              <p className="text-[15px] text-slate-700 leading-relaxed">
                „{t.quote}“
              </p>
              <div className="mt-6 pt-5 border-t border-slate-100 flex items-center gap-3">
                <div className="flex items-center justify-center w-11 h-11 rounded-full bg-blue-600 text-white font-bold text-[15px]">
                  {t.name.split(" ").map((n) => n[0]).join("")}
                </div>
                <div>
                  <div className="text-[15px] font-bold text-slate-900">{t.name}</div>
                  <div className="text-[13px] text-slate-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
